import React from "react";

interface Props {
  tagListName: string;
  tag: any;
  handleSelectionData: Function;
}
const Loader: React.FC = () => {
  return (
    <div className="loader-wrapper">
     <div className="loader"></div>
    </div>
  );
};
export default Loader;